<div class="control-message-item" *ngIf="errorMessage !== null">
  <span class="form-error" style="font-size: 16px;">{{errorMessage()}}</span>
</div>